"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.brlFormatter = void 0;
const { format } = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });
exports.brlFormatter = format;
//# sourceMappingURL=money.js.map